export const categories = [
  { id: 'download', name: '下载安装', slug: 'download', description: '蘑菇视频App各平台下载与安装教程', icon: 'ri-download-cloud-2-line' },
  { id: 'tutorial', name: '使用教程', slug: 'tutorial', description: '从入门到精通的使用指南', icon: 'ri-book-open-line' },
  { id: 'features', name: '功能特色', slug: 'features', description: '了解蘑菇视频的核心功能亮点', icon: 'ri-star-line' },
  { id: 'faq', name: '常见问题', slug: 'faq', description: '用户常见问题与解决方案汇总', icon: 'ri-question-line' },
];